import angular from 'angular'

import { $rootScope } from '../../ng-compat/imports'
import template from './vd-quick-keys.html'

/**
 * Directive for rendering a given quick key layout.
 *
 * @module vendQuickKeys.vdQuickKeys
 */
angular
  .module('vendQuickKeys')
  .directive('vdQuickKeys', function ($templateCache) {
    return {
      restrict: 'E',
      scope: {
        layoutData: '=',
        editMode: '=',
        layoutDataAdaptor: '=',
      },
      template,
      bindToController: true,
      controllerAs: 'vdQuickKeysCtrl',
      controller(this: $TSFixMe, $scope, $element, QuickKeysLayout) {
        this.$onInit = function () {
          this.layout = new QuickKeysLayout(this.layoutData, {
            editable: this.editMode,
          })

          // Trigger a digest when quick keys are locked/unlocked so the UI updates accordingly
          this.layout.on('quick-keys-locked', (event: $TSFixMe) =>
            $scope.$applyAsync()
          )
          this.layout.on('quick-keys-unlocked', (event: $TSFixMe) =>
            $scope.$applyAsync()
          )

          this.layout.on('quick-key-selected', (qkProductDetails: $TSFixMe) => {
            $rootScope.$emit('vd-quick-keys:product-selected', qkProductDetails)
          })
        }

        $scope.$watch('vdQuickKeysCtrl.layoutData', () =>
          this.layout.updateLayout(this.layoutData)
        )

        $scope.$watch(
          'vdQuickKeysCtrl.editMode',
          (newVal: $TSFixMe, oldVal: $TSFixMe) => {
            const editable = Boolean(newVal)
            this.layout.editable = editable
            $element.toggleClass('vd-quick-keys--edit-mode', editable)
          }
        )

        $scope.$watch(
          'vdQuickKeysCtrl.layoutDataAdaptor',
          (adaptor: $TSFixMe) => {
            if (adaptor) {
              adaptor._registerQuickKeysLayout(this.layout)
            }
          }
        )
      },
      link(scope, element, attrs) {
        attrs.$addClass('vd-quick-keys')
      },
    }
  })
